import {
  IFSecureOrchestrator,
  IFtthOrchestrator,
  IMobileOrchestrator,
} from "@nju/data-access-portal-orchestrator";

export function resolveBadge(
  orchestrator:
    | IFtthOrchestrator
    | IMobileOrchestrator
    | IFSecureOrchestrator
    | undefined,
) {
  if (
    orchestrator &&
    orchestrator.state !== "START" &&
    orchestrator.state !== "COMPLETED"
  ) {
    return "w trakcie";
  }

  return;
}
